import { DefaultOptionType } from 'antd/lib/select'
import isArray from 'lodash/isArray'

export const addMaxLengthToSelectInputWithClassName = (className: string, maxLength: string) => {
	const selects = document.getElementsByClassName(className)
	const select = selects?.[0]

	if (!select) {
		return
	}

	const inputsNode = select.getElementsByTagName('input')
	const inputNode = inputsNode?.[0]

	if (!inputNode) {
		return
	}

	inputNode.setAttribute('maxLength', maxLength)
}

export const parseInputLabel = (
	option: DefaultOptionType | DefaultOptionType[] | undefined
): string | undefined => {
	if (!option) {
		return
	}

	if (isArray(option)) {
		return
	}

	if (typeof option.label !== 'string') {
		return option.textLabel
	}

	return option.label
}
